import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { IconButton, Typography } from '@material-tailwind/react';

interface Props {
	onNext?: () => void;
	onPrev?: () => void;
	activePage: number;
	setActivePage: (activePage: number) => void;
	setPageSize?: (pageSize: number) => void;
	pageSize?: number;
	prevDisabled?: boolean;
}

export function Pagination({
	onNext = () => {},
	onPrev = () => {},
	activePage,
	setActivePage,
	prevDisabled = false,
	setPageSize = (pageSize) => {},
	pageSize,
}: Props) {
	const next = () => {
		onNext();
		setActivePage(activePage + 1);
	};

	const prev = () => {
		if (activePage === 1) return;
		onPrev();
		setActivePage(activePage - 1);
	};

	return (
		<div className="flex justify-center items-center gap-8 py-4 w-full">
			{!prevDisabled && <IconButton
				size="sm"
				variant="outlined"
				color="blue-gray"
				onClick={prev}
				disabled={activePage === 1}
			>
				<ArrowLeftIcon strokeWidth={2} className="h-4 w-4" />
			</IconButton>
			}
			<Typography color="gray" className="font-normal flex flex-row gap-x-2">
				Page{' '}
				<strong className="text-blue-gray-900">{activePage}</strong>
				{pageSize && <div className='flex flex-row items-center'> {`(`}<select onChange={(e) => setPageSize(Number(e.target.value))}>
					<option value={10}>10</option>
					<option value={20}>20</option>
					<option value={30}>30</option>
					<option value={40}>40</option>
					<option value={50}>50</option>
				</select><div>{`results per page)`}</div></div>}
			</Typography>
			<IconButton
				size="sm"
				variant="outlined"
				color="blue-gray"
				onClick={next}
			>
				<ArrowRightIcon strokeWidth={2} className="h-4 w-4" />
			</IconButton>
		</div>
	);
}
